import type { TSkeletons } from '@frontend/pole-ui/lib/components/Skeleton'

export const articlePreviewBannerSkeletons: TSkeletons = [
  { className: 'article-preview-banner__image', height: null },
  { className: 'article-preview-banner__title', width: null },
]
